import React from 'react';
import style from './style.css';
import {Flex, MarkdownDisplay} from '/app/src/component';
import Arrow from '/app/src/component/Arrow';
class Item extends React.Component {
    constructor(props) {
        super(props)
        this.state = {expand: false};

        this._handleExpandClick = this._handleExpandClick.bind(this)
    }

    _handleExpandClick(e){
        e.stopPropagation()
        this.setState({expand: !this.state.expand});
    }

    render(){
        if(this.props.searchInput){
            let searchInput = this.props.searchInput.toLowerCase()
            if(!this.props.response.quick_response.toLowerCase().includes(searchInput)){
                return null;
            }
        }
        let text = this.props.response.quick_response;
        let title = this.props.response.title;

        let direction=this.state.expand?'up':'down';

        return(
        <Flex className={style.Item} onClick={this.props.onClick}>
            <Flex basis='90%' className={style.ItemText} column>
                <Flex fontWeight='400'>{title}</Flex>
                { this.state.expand &&
                <Flex fontWeight='300'><MarkdownDisplay text={text}/></Flex>
                }
            </Flex>
            <Flex basis='10%' className={style.ExpandButton}
                onClick={this._handleExpandClick} hAlignContent='center'
                vAlignContent='center'>
                <Arrow direction={direction} onClick={this._handleExpandClick} color='lightgrey' hover='grey'/>
            </Flex>
        </Flex>
        )
    }
}


export default Item;



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/Conversation/QuickResponseModal/Item.js